module.exports = __webpack_public_path__ + "static/media/mapfre_certificado_de_cobertura_hurto_y_robo.1ccb7c1e.pdf";